import { lazy } from 'react';

const CategoryList = lazy(() => import('./category-list'));;
const CategoryDetail = lazy(() => import('./category-detail'));;

export default {
  CategoryList,
  CategoryDetail,
};
